import { FC } from 'react'

import { ProductCardProps } from '../ProductCard'

import * as SC from './styled'

export type ProductsGridProps = {
  className?: string
  items?: ProductCardProps[]
  noItemText?: string
}

const ProductsGrid: FC<ProductsGridProps> = ({ items, noItemText }) => {
  return items?.length ? (
    <SC.BestProductsWrapper>
      {items?.map((item, index) => (
        <SC.BestProductsItem {...item} key={index} />
      ))}
    </SC.BestProductsWrapper>
  ) : (
    <SC.NoItemText>{noItemText}</SC.NoItemText>
  )
}

export default ProductsGrid
